export default __webpack_public_path__ + "static/media/United.5b5db4aa.png";